import errors from '@feathersjs/errors';

export default function createErrorHandlerHook() {
  return function error_handler( ctx ) {
    if ( ! ctx.error ) return ctx;
    const error = ctx.error;
    if ( ! error.code ) {
      ctx.error = new errors.GeneralError( 'server error' );
      return ctx;
    }
    // eslint-disable-next-line no-process-env
    if ( error.code === 404 || process.env.NODE_ENV === 'production' ) {
      error.stack = null;
    }
    return ctx;
  };
}
